import React, { memo } from "react";

import { transformDateToLocalDateString } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import {
  countTires,
  formatTireDimension,
  TIRE_SET_INTRO_SAMPLE,
} from "ui/modules/fleet/tires/pages/TireSetEditCard/components/TireSetIntro/consts";

import { getMountVehicle, TIRE_SET_MOUNT_INTRO_SAMPLE } from "../consts";
import { TireSetMountSceneProps } from "../types";

/** Korak "Vozilo": set guma sa skladišta ide na vozilo, odabrano vozilo i promjena lokacije. */
const MountVehicleScene: React.FC<TireSetMountSceneProps> = (props) => {
  const { currentSet, formValues } = props;
  const vehicle = getMountVehicle(props);
  const code = currentSet.code || TIRE_SET_INTRO_SAMPLE.code;
  const dimension = formatTireDimension(currentSet.tires[0]) || TIRE_SET_INTRO_SAMPLE.dimension;
  const quantity = countTires(currentSet.tires) || TIRE_SET_INTRO_SAMPLE.quantity;
  const from = currentSet.warehouse?.name || TIRE_SET_MOUNT_INTRO_SAMPLE.fromWarehouse;
  const date = transformDateToLocalDateString(formValues.transferDate ?? new Date());

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          {/* Slika ima bijelu podlogu kao kartica, pa bez okvira. */}
          <div className="h-[5.5rem] overflow-hidden">
            <img src={TIRE_SET_INTRO_SAMPLE.image} alt="" className="w-full h-full object-contain scale-[1.35]" />
          </div>
          <div className="mt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">{code}</div>
          <div className="text-sm font-bold text-slate-800 truncate">
            {dimension} · {quantity} kom
          </div>

          {/* Ruta: skladište gore, vozilo dolje, isprekidana crta između. */}
          <div className="mt-3 flex gap-3">
            <div className="flex flex-col items-center pt-1">
              <span className="w-3 h-3 rounded-full border-2 border-slate-400 bg-white" />
              <span className="flex-1 w-px my-1 border-l-2 border-dashed border-slate-300" />
              <span className="w-3 h-3 rounded-full bg-blue-600 ring-4 ring-blue-100" />
            </div>
            <div className="flex-1 min-w-0 space-y-3">
              <div>
                <div className="text-[0.6rem] text-slate-400">Skladište</div>
                <div className="text-[0.75rem] font-semibold text-slate-500 truncate">{from}</div>
              </div>
              <div>
                <div className="text-[0.6rem] text-blue-500 font-semibold">Vozilo</div>
                <div className="text-sm font-bold text-slate-800 truncate">{vehicle.name}</div>
              </div>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="h-[5rem] rounded-md bg-gradient-to-br from-slate-50 to-slate-100 p-[10px]">
            <img src={vehicle.image} alt="" className="w-full h-full object-contain" />
          </div>
          <div className="mt-3 text-xs font-bold text-slate-800 truncate">{vehicle.name}</div>
          <div className="text-[0.65rem] text-slate-400 truncate">{vehicle.registration || "Registracija"}</div>
          <div className="mt-2 flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
            <span className="text-slate-500">Montaža</span>
            <span className="font-semibold text-slate-800">{date}</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Set prelazi na vozilo"
          subtitle="Lokacija seta se ažurira sama"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(MountVehicleScene);
